import { BILLING_EXPENSE_VALUE_MAX, BILLING_EXPENSE_VALUE_MIN } from "../consts/billing";
import { BillingStep } from "../types/billing";
import { BillingStatus, IBilling, IBillingExpense } from "../types/billings";
import { generateRandomId } from "./id";

export const createBillingExpenseFromPartial = (partial?: Partial<IBillingExpense>): IBillingExpense => {
  return {
    // Assign a unique local ID to ensure multiple new expenses have distinct IDs before saving
    id: partial?.id || generateRandomId(),
    apiId: partial?.apiId,
    name: partial?.name || "",
    value: partial?.value || "",
    real: partial?.real || false,
  };
};

export const getValidatedBillingExpenseInputValue = (value: string): IBillingExpense["value"] => {
  if (value === "") {
    return "";
  }

  const numberValue = Number(value);

  if (numberValue < BILLING_EXPENSE_VALUE_MIN) {
    return String(BILLING_EXPENSE_VALUE_MIN);
  }
  if (numberValue > BILLING_EXPENSE_VALUE_MAX) {
    return String(BILLING_EXPENSE_VALUE_MAX);
  }

  return value;
};

export const calculateBillingExpensePerKg = (expenses: IBillingExpense[], expectedWasteAmount: number): number => {
  const totalExpenses = expenses.reduce((sum, expense) => sum + Number(expense.value), 0);

  if (expectedWasteAmount === 0) {
    return 0;
  }

  return totalExpenses / expectedWasteAmount;
};

export const getDefaultBillingStep = (status: BillingStatus, hasBeenSaved: IBilling["hasBeenSaved"]): BillingStep => {
  if (status === BillingStatus.Active || status === BillingStatus.Closed) {
    return BillingStep.Billing;
  }

  if (hasBeenSaved) {
    return BillingStep.Calculation;
  }

  return BillingStep.Costs;
};
